import { lazy } from "react";

const StoreSettings = lazy(() => import("../Ecommerce/StoreSettings/StoreSettings"));

// The online shop's back office. Phase 0 is the settings screen; products, orders,
// deliveries and delivery areas join this file as they are built.
export const ecommerceRoutes = (access, settings) => {
  if (!settings?.fiscalYearId) return [];

  const routes = [];

  if (access?.ecomSettingsAccess) {
    routes.push({ path: "/ecom_store_settings", element: StoreSettings, title: "ecomStoreSettings" });
  }

  return routes;
};
